import { render, staticRenderFns } from "./ValueAssessmentDetail.vue?vue&type=template&id=b72154a8&scoped=true"
import script from "./ValueAssessmentDetail.vue?vue&type=script&lang=js"
export * from "./ValueAssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./ValueAssessmentDetail.vue?vue&type=style&index=0&id=b72154a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72154a8",
  null
  
)

export default component.exports